export { default } from './euras-offline-documents';
